import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { BusinessDaysClient } from "../../../../../../Wrap/Api/Common/BusinessDays";

export class BusinessDaysAction {
    public static GetBusinessDays(BaseDate: Date, Future: boolean, NumberOfDays: number, Max: boolean, callback) {
        const client = new BusinessDaysClient();
        client.get(NumberOfDays, Future ? 1 : 2, JsonDateParser.toJsonDateNoOffset(BaseDate), Max).onSuccess((d) => {
            callback(d);
        });
    }
}
